import Navbar from "../Components/Navigation/Navbar";
import Events from "../Components/Events/Events";
import React from "react";
import '../index.css';
import './home.css'
import {Button, Card, Col, Container, Row} from "react-bootstrap";
import RandomPic from "../Components/gallery/picoftheday";


function homePage() {
    return (<>
        <div className="App">
            <title>TSC Stahl Hennigsdorf Vereinswebsite</title>
            <Navbar/>
            <Card>
                <Card.Header>Willkommen beim Tauchsportclub Stahl Hennigsdorf e.V.</Card.Header>
                <Card.Body>
                    <Card.Text>
                        <>
                            Tauchen und Schnorcheln zählen zu den faszinierendsten Aktivitäten in der Natur. Dabei bewegen wir uns jedoch in einer Umgebung, die für den Menschen herausfordernd ist.
                            <br/>
                            <br/>
                            Eine solide Ausbildung ist daher essenziell. Regelmäßiges Training stärkt die Kondition, verbessert die Fähigkeiten und erhöht die Sicherheit.
                            Der Schutz der Unterwasserwelt und die Freude am Sport hängen eng mit unserer Erfahrung zusammen.
                            Wer sicher schnorchelt oder taucht, genießt den Urlaub am Meer oder See umso mehr.
                            <br/>
                            <br/>
                            Wir bieten eine umfassende Ausbildung ohne Zeitdruck und zu fairen Kosten. Falls nötig, kann die Ausrüstung bei uns ausgeliehen werden.
                            <br/>
                            <br/>
                            Auf den folgenden Seiten erfährst du mehr über unseren Verein und über den fantastischen Freizeitsport Tauchen.
                            <br/>
                            <br/>
                            Wir sind Mitglied im{' '}
                            <a href="https://www.vdst.de/" target="_blank" rel="noopener noreferrer">
                                VDST
                            </a>{' '}
                            und bilden nach den Richtlinien des VDST und der CMAS Taucher bis zum Brevet CMAS/GDL ***
                            aus.
                            <br/>
                            <br/>
                            <span style={{ fontSize: "1.5em", fontWeight: "bold" }}>
                                Der Verein, mehr als nur die Summe seiner Mitglieder!
                            </span>
                        </>
                    </Card.Text>


                </Card.Body>

                <Container fluid>
                    <Row xs={1} sm={1} xl={2}>
                        <Col>
                            <Events previewLimit={3}/>
                        </Col>
                        <Col>
                            {/* Entferne die Card um das Foto des Tages */}
                            <RandomPic/>
                        </Col>
                    </Row>
                </Container>

            </Card>
        </div>
        <Card className="impressum">
            <Button variant="Link" href="/impressum">Impressum</Button>
        </Card>
    </>);

}

export default homePage;
